module.exports = __webpack_public_path__ + "img/specifi_logo_white.867e3911.svg";